export default {
  name: "tab-pane",
  props: {
    list: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    searchForm: {
      type: Object,
    },
    totalNum: {
      type: Number,
    },
    pageNum: {
      type: Number,
    },
    isSeller: {
      type: Number,
    },
  },
  data() {
    return {
      env: process.env,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 90 * 24 * 3600 * 1000;
        },
      },
      orderTypeList: [
        {
          value: "0",
          text: "普通订单",
        },
        {
          value: "2",
          text: "集采订单",
        },
        {
          value: "3",
          text: "代采订单",
        },
        {
          value: "4",
          text: "预订单",
        },
      ],
      deliveryList: [
        {
          value: "1",
          text: "配送",
        },
        {
          value: "2",
          text: "自提",
        },
      ],
      orderVehicleStatusList: [
        {
          value: "0",
          text: "未确认",
        },
        {
          value: "1",
          text: "已确认",
        },
      ],
    };
  },

  methods: {
    arraySpanMethod: ({ row, columnIndex }) => {
      if (!row.id) {
        if (columnIndex === 0) {
          return [1, 5];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    submitOrderList() {
      this.searchForm.pageNum = 1;
      this.$emit("handleClick", this.searchForm);
    },
    currentChange(current) {
      this.searchForm.pageNum = current;
      this.$emit("handleClick", this.searchForm);
    },
    exportOrderList() {
      this.$emit("exportOrderList", this.searchForm);
    },
    resetOrderList() {
      this.$emit("resetOrderList", this.searchForm);
    },
    buttonSubmit(item, order) {
      if (item.isGraySetting == "1") {
        return;
      }
      this.$emit("buttonSubmit", item, order);
    },
  },
};
